<template>
  <crud-editor
    ref="editor"
    :is-edit="false"
    :definition="definition"
    :disabled="hasNoEditPermission"
    :save="() => {}"
    :form-has-changed="
      () => {
        return false;
      }
    "
    :return-to="returnTo"
    :item-type="entity"
    :page-loading="loading"
    :inject-form-values="injectFormValues"
    :get-layout="layout"
    :show-delete-button="false"
    :show-save-and-close-button="false"
    :show-save-and-next-button="false"
    :show-save-button="false"
  >
  </crud-editor>
</template>
<script>
import CrudEditor from '@/components/crud/TabbedEditor';
import formMixin from './form-mixin';
import { hasEditPermissionForCode } from '@/utils/permission';
import { getLayoutDefinition } from './form.js';

export default {
  components: {
    CrudEditor
  },
  mixins: [formMixin],
  data: () => ({
    isEdit: true,
    layout: getLayoutDefinition
  }),
  computed: {
    hasNoEditPermission() {
      return !hasEditPermissionForCode(this.entity, this.$store.getters.permissions);
    },
    loading() {
      return this.$store.getters[this.entityStore + '/isLoading'];
    }
  }
};
</script>
